export default function (quantitySelector, container) {
  let quantityWrapper;

  if (container) {
    quantityWrapper = container.querySelector(quantitySelector);
  } else {
    quantityWrapper = this.container.querySelector(quantitySelector);
  }

  const quantityInput = quantityWrapper.querySelector('[data-quantity-input]');
  const addQuantity = quantityWrapper.querySelector(
    '.product-form__quantity-add-item'
  );
  const subtractQuanity = quantityWrapper.querySelector(
    '.product-form__quantity-subtract-item'
  );

  const handleAddQuantity = () => {
    const currentValue = parseInt(quantityInput.value);
    const newValue = currentValue + 1;

    quantityInput.value = addLeadingZero(newValue);
    quantityInput.dispatchEvent(new Event('change'));
  };

  const handleSubtractQuantity = () => {
    const currentValue = parseInt(quantityInput.value);

    if (currentValue === 1) return;

    const newValue = currentValue - 1;
    quantityInput.value = addLeadingZero(newValue);
    quantityInput.dispatchEvent(new Event('change'));
  };

  const addLeadingZero = number => {
    let s = number + '';
    if (s.length < 2) {
      s = '0' + s;
    }

    return s;
  };

  addQuantity.addEventListener('click', handleAddQuantity);
  subtractQuanity.addEventListener('click', handleSubtractQuantity);

  return () => {
    addQuantity.removeEventListener('click', handleAddQuantity);
    subtractQuanity.removeEventListener('click', handleSubtractQuantity);
  };
}
